module.exports = __webpack_public_path__ + "static/media/card-Visa-inactive.a897268e.svg";